/* eslint-disable jsx-a11y/alt-text */
import React, { useState, useEffect } from 'react';
import iconHamburger from '../icons/hamburger.svg';
import iconCross from '../icons/cross-icon.svg';
import iconTg1 from '../icons/tg-1.svg';
import iconX1 from '../icons/x-1.svg';
import { useAccount } from 'wagmi';
import { Link } from 'react-router-dom';
import formatNumber, { imageUrl, apiUrl, coinNames, projectName } from '../utils/constants.ts';
import { useTheme } from '../context/ThemeContext';
import iconLight from '../icons/sun.svg';
import iconDark from '../icons/moon.svg';
import { useAppKit } from '@reown/appkit/react'

const TopBar = () => {
  const [isExpanded, setIsExpanded] = useState(false);
  const { address } = useAccount();
  const { theme, toggleTheme } = useTheme();

  // Toggle theme and save to localStorage
  const handleThemeToggle = () => {
    const newTheme = theme === 'light' ? 'dark' : 'light';
    toggleTheme(newTheme);
    localStorage.setItem('theme', newTheme);
  };

  const handleHamburgerClick = () => {
    setIsExpanded(!isExpanded);
  };
  const [history, setHistory] = useState([]);

  useEffect(() => {
    // Add event listener for window resize
    const handleResize = () => {
      if (window.innerWidth >= 640) {
        setIsExpanded(false);
      }
    };

    window.addEventListener('resize', handleResize);
    // Clean up the event listener when the component unmounts
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {
    const FetchData = async () => {
      try {
        await fetch(
          apiUrl + `/getHistory`,
          {
            method: 'GET'
          }
        ).then(async res => {
          let data = await res.json();
          if (data.length > 0) {
            let history;
            let historyData = [];
            for (let i = 0; i < data?.length; i++) {
              if (data[i].chainId !== undefined) {
                let chainId = data[i].chainId;
                let amount = data[i].amount;
                let buyer = data[i].buyer;
                let name = data[i].name;
                let token = data[i].token;
                let type = data[i].type;
                let contract = data[i].contract;
                let avatarUrl = imageUrl + "profile-" + data[i].buyer + ".png";
                history = { chainId, amount, buyer, name, token, type, contract, avatarUrl };
                historyData.push(history);
              }
            }
            setHistory(historyData);
          }
        });
      } catch (e) {
        console.error(e);
      }
    };
    FetchData();
  }, []);

  let currentPath = window.location.pathname;

  const { open } = useAppKit()

  return (
    <>
      <div className="w-full overflow-hidden  h-8 bg-[var(--section-bg)]">
        {history.length > 0 && (
          <div className='overflow-hidden  w-full h-full'>
            <div className="flex absolute top-20 left-0 h-24 gap-0.5 w-max animate-slide ">
              {history.map(({ chainId, amount, buyer, name, token, contract, type, avatarUrl }, i) => (
                <div
                  className="flex relative justify-center items-center px-3 py-1 rounded bg-[var(--card-bg)] border border-transparent"
                  style={{
                    background: 'var(--card-bg) padding-box, var(--card-border) border-box',
                    border: '1px solid transparent',
                    borderRadius: 'var(--card-radius)'
                  }}
                  key={i}
                >
                  <Link
                    className="flex justify-center items-center no-underline text-sm ml-1.5"
                    style={{ color: 'var(--text-secondary)' }}
                    to={'/profile/?address=' + buyer}
                    target={currentPath.includes('profile') ? '_blank' : ''}
                    rel="noreferrer"
                  >
                    {buyer.slice(0, 4) + '...' + buyer.slice(-3)}
                  </Link>
                  <span
                    className="pl-3 text-sm"
                    style={{ color: type === "bought" ? 'var(--progress-fill)' : '#ef4444' }}
                  >
                    {type === "bought" ? "+" : "-"}
                  </span>
                  <span
                    className="text-sm ml-1.5 inline-flex items-center gap-1"
                    style={{ color: 'var(--text-secondary)' }}
                  >
                    <span>
                      {formatNumber(Number(amount))}
                    </span>
                    <span>
                      {type === 'bought' ? coinNames[chainId] : 'Token'}
                    </span>
                  </span>
                  <Link
                    className="flex items-center no-underline ml-1.5"
                    style={{ color: 'var(--text-secondary)' }}
                    to={`/buy/?chain=${chainId}&address=${contract}`}
                    rel="noreferrer"
                  >
                    <span
                      className="text-sm font-bold ml-1.5"
                      style={{ color: 'var(--text-accent)' }}
                    >
                      {name.length > 6 ? `${name.slice(0, 6)}...` : name}
                    </span>
                    <img
                      src={imageUrl + 'logo/' + projectName + "-" + chainId + "-" + contract + '.png'}
                      width="24"
                      height="24"
                      alt=""
                      className="ml-1.5 mr-2.5 rounded-full"
                    />
                  </Link>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
      <div className="fixed top-0 left-0 w-full z-50 py-3 px-4 border-b-2" style={{ background: 'var(--header-bg)', borderColor: 'var(--header-bottom-border)' }}>
        <div className={`my-0 max-w-7xl mx-auto w-full items-center ${isExpanded ? 'pb-2' : ''}`}>
          <div className='flex justify-between'>
            <div className='flex flex-row items-center'>
              <Link to="/">
                <img
                  src="/logo.png"
                  className="h-20 min-w-20"
                  alt="DogWifHair logo"
                />
              </Link>
              <div className="xl:flex hidden flex-row gap-4 ml-6 font-['Bricolage_Grotesque',_sans-serif]">
                <Link to="/dashboard" className="px-4 py-2 rounded-lg transition-colors"
                  style={{
                    backgroundColor: currentPath === '/' || currentPath === '/dashboard'
                      ? 'var(--nav-button-active-bg)'
                      : 'var(--nav-button-inactive-bg)',
                    color: currentPath === '/' || currentPath === '/dashboard'
                      ? 'var(--nav-button-active-text)'
                      : 'var(--nav-button-inactive-text)'
                  }}>
                  Dashboard
                </Link>
                <Link to="/create" className="px-4 py-2 rounded-lg transition-colors"
                  style={{
                    backgroundColor: currentPath === '/create'
                      ? 'var(--nav-button-active-bg)'
                      : 'var(--nav-button-inactive-bg)',
                    color: currentPath === '/create'
                      ? 'var(--nav-button-active-text)'
                      : 'var(--nav-button-inactive-text)'
                  }}>
                  Create
                </Link>
                <Link to={`/profile/?address=${address}`} className="px-4 py-2 rounded-lg transition-colors"
                  style={{
                    backgroundColor: currentPath.includes('/profile')
                      ? 'var(--nav-button-active-bg)'
                      : 'var(--nav-button-inactive-bg)',
                    color: currentPath.includes('/profile')
                      ? 'var(--nav-button-active-text)'
                      : 'var(--nav-button-inactive-text)'
                  }}>
                  Profile
                </Link>
                <Link to="/about" className="px-4 py-2 rounded-lg transition-colors"
                  style={{
                    backgroundColor: currentPath === '/about'
                      ? 'var(--nav-button-active-bg)'
                      : 'var(--nav-button-inactive-bg)',
                    color: currentPath === '/about'
                      ? 'var(--nav-button-active-text)'
                      : 'var(--nav-button-inactive-text)'
                  }}>
                  About
                </Link>
              </div>
            </div>
            <div className='flex flex-row items-center gap-4'>
              <div className='sm:flex hidden flex-row gap-4 items-center'>
                <button onClick={handleThemeToggle} className="p-2">
                  {theme === 'light' ?
                    <img src={iconDark} className='w-6 h-6' alt="Dark mode" /> :
                    <img src={iconLight} className='w-6 h-6' alt="Light mode" />
                  }
                </button>
                <a href="https://x.com/DogWifHair" target="_blank" className="p-2" rel="noreferrer">
                  <img src={iconX1} className={`w-6 h-6 ${theme === 'light' ? 'filter invert' : ''}`} />
                </a>
                <a href="https://t.me/dogwifhaircoin" target="_blank" className="p-2" rel="noreferrer">
                  <img src={iconTg1} className={`w-6 h-6 ${theme === 'light' ? 'filter invert' : ''}`} />
                </a>
              </div>
              <button className='px-4 py-2 rounded-lg transition-colors' onClick={() => open()}
                style={{ background: 'var(--nav-button-active-bg)', color: 'var(--nav-button-active-text)' }}>
                {address ? `${address?.slice(0, 6)}...${address?.slice(-4)}` : 'Connect Wallet'}
              </button>
              <button className='rounded-full p-2 flex xl:hidden' onClick={handleHamburgerClick} style={{
                background: 'var(--button-bg)',
                color: 'var(--button-text)'
              }}>
                <img
                  src={isExpanded ? iconCross : iconHamburger}
                  className='w-8 h-8'
                  style={{ filter: theme === 'light' ? 'invert(0)' : 'invert(1)' }}
                />
              </button>
            </div>
          </div>
          {isExpanded && (
            <div className='relative rounded-[25px] flex flex-col gap-4 px-8 pt-10 pb-40 sm:p-12 w-full items-center overflow-hidden mt-4' style={{
              background: 'var(--card-bg)',
              border: '2px solid var(--card-border)'
            }}>
              <div className='flex flex-col gap-4 w-full'>
                <Link to="/dashboard" className="px-4 py-3 rounded-lg text-center transition-colors"
                  style={{
                    backgroundColor: currentPath === '/' || currentPath === '/dashboard'
                      ? 'var(--nav-button-active-bg)'
                      : 'var(--nav-button-inactive-bg)',
                    color: currentPath === '/' || currentPath === '/dashboard'
                      ? 'var(--nav-button-active-text)'
                      : 'var(--nav-button-inactive-text)'
                  }}>
                  Dashboard
                </Link>
                <Link to="/create" className="px-4 py-3 rounded-lg text-center transition-colors"
                  style={{
                    backgroundColor: currentPath === '/create'
                      ? 'var(--nav-button-active-bg)'
                      : 'var(--nav-button-inactive-bg)',
                    color: currentPath === '/create'
                      ? 'var(--nav-button-active-text)'
                      : 'var(--nav-button-inactive-text)'
                  }}>
                  Create Token
                </Link>
                <Link to={`/profile/?address=${address}`} className="px-4 py-3 rounded-lg text-center transition-colors"
                  style={{
                    backgroundColor: currentPath.includes('/profile')
                      ? 'var(--nav-button-active-bg)'
                      : 'var(--nav-button-inactive-bg)',
                    color: currentPath.includes('/profile')
                      ? 'var(--nav-button-active-text)'
                      : 'var(--nav-button-inactive-text)'
                  }}>
                  Profile
                </Link>
                <Link to="/about" className="px-4 py-3 rounded-lg text-center transition-colors"
                  style={{
                    backgroundColor: currentPath === '/about'
                      ? 'var(--nav-button-active-bg)'
                      : 'var(--nav-button-inactive-bg)',
                    color: currentPath === '/about'
                      ? 'var(--nav-button-active-text)'
                      : 'var(--nav-button-inactive-text)'
                  }}>
                  About
                </Link>
              </div>
              <div className='sm:hidden flex flex-row gap-4 items-center mt-6'>
                <button onClick={handleThemeToggle} className="p-2">
                  {theme === 'light' ?
                    <img src={iconDark} className='w-6 h-6' alt="Dark mode" /> :
                    <img src={iconLight} className='w-6 h-6' alt="Light mode" />
                  }
                </button>
                <a href="https://x.com/DogWifHair" target="_blank" className="p-2" rel="noreferrer">
                  <img src={iconX1} className={`w-6 h-6 ${theme === 'light' ? 'filter invert' : ''}`} />
                </a>
                <a href="https://t.me/dogwifhaircoin" target="_blank" className="p-2" rel="noreferrer">
                  <img src={iconTg1} className={`w-6 h-6 ${theme === 'light' ? 'filter invert' : ''}`} />
                </a>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default TopBar;
